import React from "react";
import PropTypes from "prop-types";

const OContactCard = ({
    title,
    contactName,
    contactEmail,
    contactPhone,
    contactTwitterDisplay,
    contactTwitterLink,
    htmlDescription,
    gradientTo,
    gradientFrom
}) => {
    const gradientStyle = {
        backgroundImage: `linear-gradient(to bottom, ${gradientFrom}, ${gradientTo}`,
        backgroundColor: `${gradientFrom}`
    };

    return (
        <footer className="relative flex flex-column justify-center items-center pv6 min-vh-100">
            <div className="ph4 ph5-ns w-100-s z-1 f5 f4-ns measure-wide">
                <div className="fira f3 lh-title mb3 mb4-ns fw5">
                    <div className="f1-ns">Contact</div>
                </div>
                <div className="lh-copy lato cms fw4">
                    <div className="lh-copy cms" dangerouslySetInnerHTML={{ __html: htmlDescription }} />
                    <div className="fw4 pt2 pb3">{contactName}</div>
                    <address className="fs-normal pb3">
                        <a className="pointer" href={`mailto:${contactEmail}`}>
                            {contactEmail}
                        </a>
                    </address>
                    <address className="fs-normal pb3">
                        <a className="pointer" href={`tel:${contactPhone.replace(/\s/g, "")}`}>
                            {contactPhone}
                        </a>
                    </address>
                    <address className="fs-normal">
                        <a className="pointer" href={`${contactTwitterLink}`}>
                            {contactTwitterDisplay}
                        </a>
                    </address>
                </div>
            </div>
            <div style={gradientStyle} className={`absolute absolute--fill wch-t z0`} />
        </footer>
    );
};

export default OContactCard;

OContactCard.propTypes = {
    title: PropTypes.string,
    contactName: PropTypes.string,
    contactEmail: PropTypes.string,
    contactPhone: PropTypes.string,
    contactTwitterDisplay: PropTypes.string,
    contactTwitterLink: PropTypes.string,
    htmlDescription: PropTypes.string,
    gradientTo: PropTypes.string,
    gradientFrom: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/OContactCard.js